<template>
    <div id="ReportPatientCensus">
      <div v-if="this.showModal">
        <MdTitle v-bind:Text="$t('CensusReport.RepTitle')" />
        <div class="row">
          <div class="col-sm-12 col-md-12 mb-4">
            <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                <div class="input-group" dir="ltr">
                      <input
                        type="text"
                        class="form-control"
                        :dir="dirInput"
                        v-model="params.SearchCriteria"
                          @keyup.enter="SearchCensus"
                      >
                      <div class="input-group-append">
                          <div class="input-group-append">
                          <MdButton
                            v-bind:Name="'btnsearchinput'"
                            v-bind:VariantProp="'btn btn-sm search-attached'"
                            v-bind:IconClass="'mdi mdi-magnify'"
                            v-on:click="SearchCensus">
                          </MdButton>
                      </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <b-row>
            <b-col lg="3" md="3" sm="12">
            <MdDateTime
                :Label="$t('Shared.datefrom')"
                :Model="params.DateFrom"
                @input="params.DateFrom = $event"
                :Id="'DateFrom'"
                :Type="'date'"
                :OnPressEnter="SearchCensus"
                :isRequired="false"
                :isConfirm="false"
                :ReadOnly="false"
                v-bind:isValid="isDateFromValid">
            </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
            <MdDateTime
                :Label="$t('Shared.dateTo')"
                :Model="params.DateTo"
                @input="params.DateTo = $event"
                :Id="'DateTo'"
                :Type="'date'"
                :OnPressEnter="SearchCensus"
                :isRequired="false"
                :isConfirm="false"
                :ReadOnly="false"
                v-bind:isValid="isDateToValid">
            </MdDateTime>
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdLookupMultiSelect
                    v-bind:Label="$tc('Shared.Program')"
                    v-bind:ModelCode="ProgramCodeModel"
                    v-bind:RefCode="'programcode'"
                    v-bind:Api="'Programs/LookUp'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('Shared.Program')"
                    :GetValues="getProgramValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="programLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdLookupMultiSelect
                    v-bind:Label="$tc('Shared.Patient', 2)"
                    v-bind:ModelCode="PatientCodeModel"
                    v-bind:RefCode="'patientcode'"
                    v-bind:Api="'Patients/LookUp'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('Shared.Patient', 2)"
                    :GetValues="getPatientValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :SearchFieldCode="'PatientCode'"
                    :AuxFields="patientAuxFields"
                    :FieldsDate="patientFieldsDate"
                    :ServerSidePagination="true"
                    v-bind:Fields="patientLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdLookupMultiSelect
                    v-bind:Label="$tc('Insurance.Insurance')"
                    v-bind:ModelCode="InsuranceCodeModel"
                    v-bind:RefCode="'insurancecode'"
                    v-bind:Api="'Insurances/Lookup'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$tc('Insurance.Insurance')"
                    :GetValues="getInsuranceValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="insuranceLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdLookupMultiSelect
                    v-bind:Label="$tc('Shared.InsuranceCategory')"
                    v-bind:ModelCode="InsuranceCategoryModel"
                    v-bind:RefCode="'InsuranceCategory'"
                    v-bind:Api="'InsuranceCategories'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'name'"
                    :SearchTitle="$tc('Shared.InsuranceCategory')"
                    :GetValues="getInsuranceCategoryValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="insuranceCategoryLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdLookupMultiSelect
                    v-bind:Label="$t('Shared.Doctors')"
                    v-bind:ModelCode="DoctorCodeModel"
                    v-bind:RefCode="'doctorcode'"
                    v-bind:Api="'Doctors/LookUp'"
                    v-bind:FieldCode="'code'"
                    v-bind:FieldDescription="'description'"
                    :SearchTitle="$t('Shared.Doctors')"
                    :GetValues="getDoctorValues"
                    :InvalidFeedback="$t('Msg.InvalidCode')"
                    :ServerSidePagination="true"
                    v-bind:Fields="doctorLookupFields"
                />
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('Shared.Gender')"
                v-bind:Options="sex_list"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:Model="genderModel"
                v-bind:Multiple="false"
                :Input="ChangeDropDownSex"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('Shared.Status')"
                v-bind:Options="statusList"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:Model="statusModel"
                v-bind:Multiple="false"
                :Input="ChangeDropDownStatus"/>
            </b-col>
             <b-col lg="3" md="3" sm="12">
              <MdSelect
                v-bind:Label="$t('CensusReport.AnticipatedDischDate')"
                v-bind:Options="yesNoList"
                v-bind:FieldDescription="'text'"
                v-bind:FieldCode="'value'"
                v-bind:Model="anticipatedDischDateModel"
                v-bind:Multiple="false"
                :Input="ChangeDropDownAnticipatedDischDate"/>
            </b-col>
            <b-col md="3" sm="12" class="ml-auto">
              <div class="text-md-right mt-3">
                  <button
                      v-on:click="SearchCensus"
                      type="button"
                      class="btn btn-primary btn-login ml-2"
                      id="btnsearchinput">
                      {{ $t('Shared.Search') }}
                  </button>
              </div>
            </b-col>
          </b-row>
        <div class="row">
          <div class="col-md-12">
              <MdTitle  v-bind:Text="$t('Shared.SearchResult')"
                        v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
              <div class="row">
                <div class="col-md-12">
                <MdTable
                  v-bind:fields="fields"
                  v-bind:items="items"
                  v-bind:totalRows="totalRows"
                  v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                  v-bind:currentPage="currentPage"
                  v-bind:perPage="perPage"
                  v-bind:pageOptions="pageOptions"
                  v-bind:refTable="refTable"
                  :pageChanged="pageChanged"
                  :perPageFunction="PerPageFunction">
                </MdTable>
              </div>
            </div>
          </div>
        </div>

        <div class="space-actions"></div>
        <div class="page-actions">
          <MdButton
            v-bind:Label="$t('Shared.Back')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="reportList"
            v-bind:Name="'btn_ReportList'"/>
          <MdButton
            v-bind:Label="$t('Shared.Report')"
            v-bind:ClassProp="'primary btn-login mx-2'"
            v-on:click="onClickShowReport"
            v-bind:Name="'btn_Print'"/>

          <b-dropdown id="dropdown-dropup" dropup :text="$t('Shared.Export')" variant="primary" class="m-2">
						<b-dropdown-item v-on:click="handlePdf('export')">{{$t('Shared.PDF')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handlePdf('email')">{{$t('Shared.PDFByEmail')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('export')">{{$t('Shared.CSV')}}</b-dropdown-item>
						<b-dropdown-item v-on:click="handleCSV('email')">{{$t('Shared.CSVByEmail')}}</b-dropdown-item>
					</b-dropdown>

        </div>
      </div>
      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('CensusReport.RepTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="patientCensus"
          :ReportName="'PatientCensusReport'"
          :ReportTitle="$t('CensusReport.RepTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
    <CSVExportHelper
      ref="csvExportHelper"
      v-bind:conformSubject="$t('CensusReport.RepTitle')"
      v-bind:sendEmailAPI="'/Utils/sendEmail'"
      v-bind:exportCsvAPI="'/PatientCensus/exportCSV'"
    >
    </CSVExportHelper>
  </div>
</template>

<script>
import Vue from 'vue'
import { DxPopup } from 'devextreme-vue/popup';
import ShowMessage from '@/components/messages/ShowMessage.js';
import Utils from '@/common/utils'
import DBFunctions from '@/common/DBFunctions.js'
import { EventBus } from '@/event-bus.js';
import EnumService from "@/services/enum.service";
import CensusService from '@/services/census.service'

export default Vue.extend({
    name: "PatientCensusRep",
    mixins: [ ShowMessage, Utils, DBFunctions ],
    components: { DxPopup },
    props: {
      PatientCode: String,
      PatientCodeList: String,
      closeWindow: Function,
      RecNo: Number,
      showModal: Boolean
    },
    data() {
        return {
          OptionsRightMenu:{
              visible:false,
              ItemsList:[],
              btnvisible:false,
              itemdisabled: false,
              PatientCode:'',
              Mode:this.edit_mode,
              favButtonAtion:false
            },
            isParamVisible: true,
            isReportVisible: false,
            reportParams: [],
            params: {
              SearchCriteria:'',
              PageNumber : null,
              PageSize:null,
              DateFrom: null,
              DateTo: null,
              PatientList: [],
              InsuranceList:[],
              ProgramList: [],
              DoctorList: [],
              Gender: null,
              Status: null,
              showAnticipatedDischDate: false,
              InsuranceCategoryList: []
            },
            parameter:{
              SearchCriteria:'',
              PageNumber : null,
              PageSize:null,
              Status: true,
            },
            PatientCodeModel: [],
            patientAuxFields: [],
            patientFieldsDate: ['dob'],
            patientLookupFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.PatientName') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob') }
            ],
            InsuranceTypesList: [],
            insType: null,
            company: null,
            isInsCodeValid: true,
            InsuranceCodeModel: [],
            insuranceLookupFields: [
                { key: 'description', sortable: true, label: this.$tc('Insurance.Insurance', 1) },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            InsuranceCategoryModel: [],
            insuranceCategoryLookupFields: [
                { key: 'name', sortable: true, label: this.$t('Shared.InsuranceCategory') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            items: [],
            fields: [
                { key: 'patientName', sortable: true, label: this.$t('Shared.PatientName'), class: 'text-rigth' },
                { key: 'patientcode', sortable: true, label: this.$tc('Shared.PatientCode'), class: 'text-rigth' },
                { key: 'dob', sortable: true, label: this.$t('Shared.Dob'), class: 'text-rigth' },
                { key: "doctor", sortable: true, label: this.$t('Shared.DoctorName'), class: "text-rigth" },
                { key: "programname", sortable: true, label: this.$tc('Shared.Program',1), class: "text-rigth" },
                { key: "referral", sortable: true, label: this.$t('PatientFaS.Referral') },
                { key: "category", sortable: true, label: this.$t('Shared.Category'), class: "text-rigth" },
                { key: "insCompany", sortable: true, label: this.$t('insuranceSetup.CompanyName'), class: "text-rigth" },
                { key: "datefrom", sortable: true, label: this.$t('Shared.datefrom'), class: "text-rigth" },
                { key: "dateTo", sortable: true, label: this.$t('Shared.dateTo'), class: "text-rigth" },
            ],
            pageOptions: [5, 10, 15 ],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,
            selected: [],
            Header:{},
            refTable: 'selectableTable',
            ShowMessageIsEmpty:true,
            SearchCriteria:"",
            dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
            ProgramCodeModel: [],
            programLookupFields: [
                { key: 'description', sortable: true, label: this.$tc('Shared.Program') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            sex_list: EnumService.Sexs,
            genderModel: null,
            DoctorCodeModel: [],
            doctorLookupFields: [
                { key: 'description', sortable: true, label: this.$t('Shared.Doctors') },
                { key: 'code', sortable: true, label: this.$t('Shared.Code') }
            ],
            isDateFromValid: true,
            isDateToValid: true,
            statusList: EnumService.PatientCensusStatus,
            statusModel: null,
            yesNoList: [
                { value: true, text: 'Yes' },
                { value: false, text: 'No' }
            ],
            anticipatedDischDateModel: null,

        }
    },
    methods: {

      ChangeDropDownAnticipatedDischDate(value) {
        this.anticipatedDischDateModel = value ? value.value : null;
        this.params.showAnticipatedDischDate = value ? value.value : null;
      },

      ChangeDropDownStatus(value) {
        this.statusModel = value ? value.value : null;
        this.params.Status = value ? value.value : null;
      },

      validate_date_range() {
        return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
      },

      // Método de validación reutilizable
      validateForm() {
        const isValid = this.validate_date_range();

        this.isDateFromValid = isValid;
        this.isDateToValid = isValid;

        // Forzar actualización del componente
        this.$forceUpdate();

        if (!isValid) {
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
            return false;
        }
        return true;
      },

      getDoctorValues(values) {
        this.DoctorCodeModel = values;
        this.params.DoctorList = values;
      },

      ChangeDropDownSex(value) {
        this.genderModel = value ? value.value : null;
        this.params.Gender = value ? value.value : null;
      },

      onShowing(e) {
        let contentElement = e.component.content();
        let titleElement = e.component._$title[0]
        contentElement.style.padding = '0px';
        titleElement.style.padding = '0px 20px'
      },

      onHiddenReport() {
        this.isReportVisible = false
        if(!this.showModal)
          this.closeWindow();
      },

      onClickClose() {
        this.closeWindow()
        this.isParamVisible = false;
      },

      reportList() {
        this.checkExistFavorite('/app/reports/patients');
        this.$router.push({ name: "reportListPatient" }).catch(()=>{});
      },

      initializeParameters() {
        ['PatientCode','recNo','insType'].forEach(
          key => this.parameter[key] = null
        );

        this.parameter.PatientCodeList = this.params.PatientCodeList && this.params.PatientCodeList !== ''
          ? this.params.PatientCodeList
          : null;

        this.parameter.InsuranceCodeList =this.params.InsuranceCodeList && this.params.InsuranceCodeList !== ''
          ? this.params.InsuranceCodeList
          : null;

        this.parameter.InsTypeList =this.params.InsTypeList && this.params.InsTypeList !== ''
          ?this.params.InsTypeList
          : null;

        this.parameter.SearchCriteria = this.SearchCriteria;
      },

      initializePdfParameters() {
        this.reportParams = []
        this.reportParams.push({ paramName: 'DateFrom', paramValue: this.params.DateFrom})
        this.reportParams.push({ paramName: 'DateTo', paramValue: this.params.DateTo})
        this.reportParams.push({ paramName: 'PatientList', paramValue: this.params.PatientList})
        this.reportParams.push({ paramName: 'InsuranceList', paramValue: this.params.InsuranceList})
        this.reportParams.push({ paramName: 'InsuranceCategoryList', paramValue: this.params.InsuranceCategoryList})
        this.reportParams.push({ paramName: 'ProgramList', paramValue: this.params.ProgramList})
        this.reportParams.push({ paramName: 'DoctorList', paramValue: this.params.DoctorList})
        this.reportParams.push({ paramName: 'Gender', paramValue: this.params.Gender})
        this.reportParams.push({ paramName: 'Status', paramValue: this.params.Status})
        this.reportParams.push({ paramName: 'showAnticipatedDischDate', paramValue: this.params.showAnticipatedDischDate})
        this.reportParams.push({ paramName: 'SearchCriteria', paramValue: this.params.SearchCriteria})
      },

      onClickShowReport() {
        this.isParamVisible = false
        this.initializePdfParameters()
        this.isReportVisible = true
        this.$refs.patientCensus.buildDocument(this.reportParams)
      },

      getPatientValues(values) {
        this.PatientCodeModel = values;
        this.params.PatientList = values;
      },

      getProgramValues(values) {
        this.ProgramCodeModel = values;
        this.params.ProgramList = values;
      },

      getInsuranceValues(values) {
        this.InsuranceCodeModel = values;
        this.params.InsuranceList = values;
      },

      getInsuranceCategoryValues(values) {
        this.InsuranceCategoryModel = values;
        this.params.InsuranceCategoryList = values;
      },

      getSearchCensus() {
        this.params.PageNumber = this.currentPage;
        this.params.PageSize = this.perPage;
        //this.initializeParameters();

        CensusService.getAllPatientCensus(this.params)
          .then((response) => {
            if(response.status == '200' && response.data && response.data.length > 0){
              this.items = response.data;
              let headerString = response.headers["x-pagination"];
              this.Header = JSON.parse(headerString);
              this.totalRows = this.Header.TotalCount;
               this.items.forEach(item => {
                if (item.dob)
                    item.dob = Utils.formatterDateToString(item.dob);
                if (item.datefrom)
                    item.datefrom = Utils.formatterDateToString(item.datefrom);
                 if (item.anticipatedDateTo)
                    item.anticipatedDateTo = Utils.formatterDateToString(item.anticipatedDateTo);

              });
            }
            if(this.items.length === 0){
              this.ShowMessageIsEmpty = true;
            }
          })
          .catch(error => {
            this.showResponseErrorMessage(error);
          });
      },

      SearchCensus(){
        this.items = [];
        this.currentPage = 1;
        this.params.PageNumber = 1;
        this.totalRows = this.items.length;
        this.getSearchCensus();
      },

      pageChanged (page) {
        this.currentPage = page;
        this.getSearchCensus();
      },

      PerPageFunction(perpage){
        this.perPage = perpage;
        this.currentPage = 1;
        this.getSearchCensus();
      },

      handleCSV(action) {
        this.initializeParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportCSV(this.params);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailCSV(this.params);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      },

      handlePdf(action) {
        this.initializePdfParameters();
        switch(action) {
          case 'export':
            this.$refs.csvExportHelper.exportToPdf('PatientCensusReport', true, false, this.reportParams);
          break;
          case 'email':
            this.$refs.csvExportHelper.emailPdf('PatientCensusReport', true, false, this.reportParams);
          break;
          default:
            console.warn('unknow action:', action);
          break;
        }
      }
    },
    mounted () {
      if(!this.showModal)
        this.onClickShowReport();

      this.OptionsRightMenu.ItemsList = [];
      let layoutStatus = this.$store.state.layoutStatus;
      switch(layoutStatus) {
        case 'L0R1':
          this.OptionsRightMenu.favButtonAtion = false;
          this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        case 'L1R0':
        case 'L1R1':
            this.OptionsRightMenu.btnvisible = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
        break;
        default:
            this.OptionsRightMenu.favButtonAtion = false;
            this.$emit('getVisibleMenu', this.OptionsRightMenu);
      }

      EventBus.$on("ShowWeel", function (isShow) {
        isShow ? this.$emit('load', true) : this.$emit('load', false);
      }.bind(this));
    },

  })
</script>
<style>
  .dxrd-report-preview-holder {
      height: 94% !important;
  }
</style>
